import { render, staticRenderFns } from "./CustomerPanelV2026.vue?vue&type=template&id=708c8074&scoped=true"
import script from "./CustomerPanelV2026.vue?vue&type=script&lang=js"
export * from "./CustomerPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./CustomerPanelV2026.vue?vue&type=style&index=0&id=708c8074&prod&scoped=true&lang=css"
import style1 from "./CustomerPanelV2026.vue?vue&type=style&index=1&id=708c8074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c8074",
  null
  
)

export default component.exports